import script from "./BaseProgressBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseProgressBar.vue?vue&type=script&setup=true&lang=ts"

import "./BaseProgressBar.vue?vue&type=style&index=0&id=22cec41f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22cec41f"]])

export default __exports__